import {wsOpened$} from '@px/streams/ws';
import {activeOrders$} from './order-active';
import {conditionalOrders$} from './order-conditional';
import {fillOrders$} from './order-fill';
import {historyOrders$} from './order-history';
import './abtest';

wsOpened$.subscribe(() => {
  activeOrders$.next([]);
  conditionalOrders$.next([]);
  fillOrders$.next([]);
  historyOrders$.next([]);
});
